import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, MapPinIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { useLanguage } from '../contexts/LanguageContext';
import { serviceAreas } from '../data/serviceAreas';
import { ui } from '../data/ui';
import { fill } from '../utils/format';
export function ServiceAreas() {
  const {
    t
  } = useLanguage();
  const [selected, setSelected] = useState(0);
  const area = serviceAreas[selected];
  return <section id="service-areas" className="section-y bg-mist" aria-labelledby="service-areas-title" data-id="element-283" data-mp="2gsryr5jnh8gx">
      <div className="container-page grid gap-12 lg:grid-cols-12 lg:gap-16" data-id="element-284" data-mp="22tigm0bvw4ab">
        <div className="lg:col-span-5" data-id="element-285" data-mp="26u2e550dd9wz">
          <SectionHeading id="service-areas-title" title={t(ui.areas.title)} subtitle={t(ui.areas.subtitle)} align="left" data-id="element-286" data-mp="26v41o8yknovl" />
          <p className="mt-6 leading-relaxed text-body" data-id="element-287" data-mp="52fw3syggpcn">{t(ui.areas.intro)}</p>
          <p className="mt-6 flex items-start gap-2 text-sm text-muted" data-id="element-288" data-mp="6a135z4p02fb">
            <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy" aria-hidden="true" data-id="element-289" data-mp="687wiju2xi7b" />
            {t(ui.areas.note)}
          </p>
          <a href="#contact" className="btn btn-green mt-8" data-id="element-290" data-mp="fzkn784562br">
            {t(ui.areas.cta)}
          </a>
        </div>

        <div className="lg:col-span-7" data-id="element-291" data-mp="b0hfth0ovk0m">
          <ul className="grid grid-cols-2 gap-2 xl:grid-cols-4" aria-label={t(ui.areas.citiesLabel)} data-id="element-292" data-mp="b1j3ckyw5yz8">
            {serviceAreas.map((a, i) => {
            const active = i === selected;
            return <li key={a.city} data-id="element-293" data-mp="3eju9d4zk4n66" data-mpi={i}>
                  <button type="button" onClick={() => setSelected(i)} aria-pressed={active} className={`flex min-h-[56px] w-full items-center gap-2 rounded-lg border px-3 text-left text-[15px] font-semibold transition-colors duration-150 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 ${active ? 'border-navy bg-navy text-white' : 'border-line bg-white text-ink hover:border-navy/40'}`} data-id="element-294" data-mp="3tf9xyuhdbqv6">
                    <CheckIcon className={`h-4 w-4 shrink-0 ${active ? 'text-leaf-light' : 'text-leaf-strong'}`} aria-hidden="true" data-id="element-295" data-mp="1kr2cjk9uv1un" />
                    <span className="whitespace-nowrap" data-id="element-296" data-mp="1pouaow13fk7a">
                      {a.city}
                      <span className="sr-only" data-id="element-297" data-mp="s2ws6ymprevc">, Ohio</span>
                    </span>
                  </button>
                </li>;
          })}
          </ul>

          <div className="mt-4 min-h-[196px] rounded-xl bg-white p-6 shadow-sm ring-1 ring-line md:p-8" aria-live="polite" data-id="element-298" data-mp="120kwaf67lyq6">
            <AnimatePresence mode="wait" initial={false} data-id="element-299" data-mp="16s2xn4c5a1bo">
              <motion.div key={area.city} initial={{
              opacity: 0,
              y: 6
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.18,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-300" data-mp="9bngciph0e0l">
                <h3 className="font-display text-xl font-bold text-ink md:text-2xl" data-id="element-301" data-mp="2rinpv76d390a">{fill(t(ui.areas.panelTitle), {
                  city: area.city
                })}</h3>
                <p className="mt-3 leading-relaxed text-body" data-id="element-302" data-mp="2ijisi46jdlpp">{t(area.description)}</p>
                <a href="#contact" className="mt-5 inline-flex items-center gap-1.5 text-sm font-semibold text-leaf-strong underline-offset-4 hover:underline" data-id="element-303" data-mp="2dlqoibsma955">
                  {fill(t(ui.areas.panelCta), {
                  city: area.city
                })}
                  <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-304" data-mp="23um95az14m9s" />
                </a>
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </section>;
}